// Safari (desktop and iOS) doesn't implement fragment-navigation-opens-<details> at all.
// It's a Chromium-only feature (added ~Chrome 96). WebKit has no equivalent, so on Safari href="#promise" scrolls toward a <details> that's still closed, the target has zero height, and nothing visible happens
// This polyfill enables hash targeting to work in Safari.

export function polyfillDetailsHashOpen() {
  const openFromHash = () => {
    const target = location.hash
      ? document.getElementById(location.hash.slice(1))
      : undefined;
    const details = target?.closest<HTMLDetailsElement>("details:not([open])");
    if (!details) return;

    details.setAttribute("open", "");

    // iOS Safari has already scrolled to `target` at its old (closed, zero-height)
    // position by the time this runs, and won't re-scroll on its own once the
    // details opens — so re-scroll explicitly now that it has real layout.
    target?.scrollIntoView();
  };

  window.addEventListener("hashchange", openFromHash);
  openFromHash(); // handle direct load / initial hash
}
